import {
  formatarValorMonetario,
  formatarValor,
  formatarValorComCasas,
} from "../../../../helpers"

export const STR_CHAVE_INDEX_PADRAO = '#';

const formatarLinha = linha => {
  if (linha.lote_minimo) {
    linha.lote_minimo = parseFloat(linha.lote_minimo).toFixed(4)
  }

  const margem = (linha.margem > 0)
    ? `${formatarValorComCasas(linha.margem , 1)}%`
    : '-';

  return {
    ...linha,
    margem,
    cobertura_geral: `${formatarValorComCasas(linha.dias_de_cobertura_geral, 1)} dias`,
    estoque_loja: formatarValor(linha.estoque_loja),
    estoque_loja_em_preco_de_custo: `R$ ${formatarValorComCasas(linha.estoque_loja_em_preco_de_custo, 0)}`,
    estoque_cd: formatarValor(linha.estoque_cd),
    estoque_cd_em_preco_de_custo: `R$ ${formatarValorComCasas(linha.estoque_cd_em_preco_de_custo, 0)}`,
    dias_de_cobertura_da_loja: `${formatarValorComCasas(linha.dias_de_cobertura_da_loja, 1)} dias`,
    dias_de_cobertura_da_cd: `${formatarValorComCasas(linha.dias_de_cobertura_da_cd, 1)} dias`,
    estoque: parseFloat(linha.estoque),
    estoque_em_preco_de_custo: `R$ ${formatarValorComCasas(linha.estoque_em_preco_de_custo, 0)}`,
    estoque_em_preco_de_venda: `R$ ${formatarValorComCasas(linha.estoque_em_preco_de_venda, 0)}`,
    projecao_de_venda: parseFloat(linha.projecao_de_venda),
    projecao_de_venda_em_preco_custo: `R$ ${formatarValorComCasas(linha.projecao_de_venda_em_preco_custo, 0)}`,
    estoque_notificado: formatarValorMonetario(linha.estoque_notificado),
    prazo_medio_pagamento_em_dias: `${formatarValor(linha.prazo_medio_pagamento_em_dias)} dias`,
    prazo_medio_recebimento_em_dias: parseFloat(linha.prazo_medio_recebimento_em_dias),
    qtde_pendente: parseFloat(linha.qtde_pendente),
    pedidos_pendentes_em_preco_custo: `R$ ${formatarValorComCasas(linha.pedidos_pendentes_em_preco_custo, 0)}`,
    sugestao_compra_em_preco_de_custo: `R$ ${formatarValorComCasas(linha.sugestao_compra_em_preco_de_custo, 0)}`,
    sugestao_compra_em_quantidade: parseFloat(linha.sugestao_compra_em_quantidade),
    sugestao_compra_em_quantidade_fixa: parseFloat(linha.sugestao_compra_em_quantidade),
    qtd_dias_sem_vender: formatarValor(linha.qtd_dias_sem_vender || 0),
    qtd_dias_da_ultima_entrada: formatarValor(linha.qtd_dias_da_ultima_entrada || 0),
    em_excesso: (Number(linha.estoque_maximo_cd_em_preco_de_custo) > 0 && Number(linha.estoque_cd_em_preco_de_custo) > Number(linha.estoque_maximo_cd_em_preco_de_custo)),
    rentabilidade: `R$ ${formatarValorComCasas(linha.rentabilidade, 1)}`
  }
};

const getIndexUnicoLinha = linha => {
  const departamento = linha.iddepartamento >= 0 ? linha.iddepartamento : STR_CHAVE_INDEX_PADRAO;
  const secao = linha.idsecao >= 0 ? linha.idsecao : STR_CHAVE_INDEX_PADRAO;
  const categoria = linha.idcategoria >= 0 ? linha.idcategoria : STR_CHAVE_INDEX_PADRAO;
  const produto = linha.idproduto >= 0 ? linha.idproduto : STR_CHAVE_INDEX_PADRAO;

  return `${departamento}-${secao}-${categoria}-${produto}`;
}

export const formatarLinhas = (linhas, nivel_expancao, fn_expandir_linha, formatar_linhas = true) => {
  return linhas.map(linha => {
    linha.index_unico_por_linha = getIndexUnicoLinha(linha);
    linha.nivel_expancao = nivel_expancao;
    linha.fn_expandir_linha = fn_expandir_linha;

    if (!formatar_linhas) {
      return linha;
    }

    return formatarLinha(linha);
  });
}
